class NotificationsQueryKeys {
  constructor(private prefix: string) {}

  getPagedNotifications() {
    return [this.prefix];
  }

  getLastNotifications() {
    return [this.prefix, 'lastNotifications'];
  }

  pollNotifications() {
    return [this.prefix, 'pollNotifications'];
  }

  pollVirusScanNotifications() {
    return [this.prefix, 'pollVirusScanNotifications'];
  }
}

export default NotificationsQueryKeys;
